/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Credittopuppay3Inputs */

const en_credittopuppay3 = /** @type {(inputs: Credittopuppay3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Continue to payment · ${i?.price}`)
};

const de_credittopuppay3 = /** @type {(inputs: Credittopuppay3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weiter zur Zahlung · ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Continue to payment · {price}" |
*
* @param {Credittopuppay3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const credittopuppay3 = /** @type {((inputs: Credittopuppay3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credittopuppay3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_credittopuppay3(inputs)
	return de_credittopuppay3(inputs)
});
export { credittopuppay3 as "creditTopUpPay" }